var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionCheats } from "./actionCheats";
export var initial = {
    isFPSDisplayVisible: false,
};
export var reducerCheats = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionCheats.ActivateOfferGroup:
            return __assign({}, state, { activeOfferGroup: action.offerGroup });
        case TypeActionCheats.ToggleFPSDisplay:
            return __assign({}, state, { isFPSDisplayVisible: !state.isFPSDisplayVisible });
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cheats/reducerCheats.ts
// module id = 2521
// module chunks = 3